function _jade_template_fn(locals) {
  locals = locals || {};
  var h = require("panel").h;
  return h("div")
}
module.exports = _jade_template_fn;